export type CreatorThanksConfig = {
  name: string;
  thankYouLine: string;
  quoteLine: string;
  tojLine: string;
  icon: string;
  youtubeLink?: string;
  twitchLink?: string;
  youtubeIcon?: string;
  twitchIcon?: string;
};

export const specialThanksCreators: CreatorThanksConfig[] = [
  {
    name: 'Big A (Atrioc)',
    thankYouLine: 'Special thanks to',
    quoteLine: '"The game is really fun, especially the Household Name category! Will definitely play it again!"',
    tojLine: 'From the Dev: Thank you for streaming the game!',
    icon: '/assets/thank-creators/atrioc-logo.jpg',
    youtubeLink: 'https://www.youtube.com/@AtriocClips',
    twitchLink: 'https://www.twitch.tv/atrioc',
    youtubeIcon: '/assets/thank-creators/youtube-icon.svg',
    twitchIcon: '/assets/thank-creators/twitch-icon.svg',
  },
  {
    name: 'Ludwig',
    thankYouLine: 'Special thanks to',
    quoteLine: '"Top 86%! That\'s good, right?"',
    tojLine: 'From the Dev: Thank you for streaming the game!',
    icon: '/assets/thank-creators/ludwig-logo.jpg',
    youtubeLink: 'https://www.youtube.com/channel/UCrPseYLGpNygVi34QpGNqpA',
    twitchLink: 'https://www.twitch.tv/ludwig',
    youtubeIcon: '/assets/thank-creators/youtube-icon.svg',
    twitchIcon: '/assets/thank-creators/twitch-icon.svg',
  },
  {
    name: 'Smart X Capital',
    thankYouLine: 'Special thanks to Ace from',
    quoteLine: '',
    tojLine: 'Thanks for being a friend of Wallstreetle and providing feedback on the game!',
    icon: '/assets/thank-creators/smartxcapital-logo.png',
    youtubeLink: 'https://www.youtube.com/@smartxcapital',
    youtubeIcon: '/assets/thank-creators/youtube-icon.svg',
  },
];
